module.exports = __webpack_public_path__ + "static/media/noto-sans-thin.ed7fd4d8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/fonts/noto-sans-thin.eot
// module id = 452
// module chunks = 0